import React from 'react';
import PaymentModal from './components/PaymentModal/PaymentModal';
import { getPaymentIdFromUrl } from './utils/urlUtils';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import './styles/modals.css';

const AppContent: React.FC = () => {
  const { t } = useLanguage();
  const paymentId = getPaymentIdFromUrl();

  if (!paymentId) {
    return (
      <div className="App">
        <div className="error-state">
          {t('paymentNotFound')}
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <PaymentModal paymentId={paymentId} />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App;
